import { CircularProgress as CircularProgressJoy} from "@mui/joy";

export function CircularProgress() {
    return (
        <div className="h-full w-full flex justify-center items-center">
            <CircularProgressJoy />
        </div>
    );
}
